export default __webpack_public_path__ + "static/media/레진_web.69baf8cc.jpg";